import { Text } from '@chakra-ui/react';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';

const MultilineText: React.FC<{ text: string; textStyle?: string }> = ({
  text,
  textStyle = 'textBody'
}) => (
  <Text textStyle={textStyle} style={{ whiteSpace: 'pre-wrap' }}>
    {typeof text === 'string' ? parseStringWithLinks(text) : text}
  </Text>
);

export default MultilineText;
